module.exports = __webpack_public_path__ + "img/close.971f6359.svg";